import { render, staticRenderFns } from "./EbillSend.vue?vue&type=template&id=f0c08872&scoped=true&"
import script from "./EbillSend.vue?vue&type=script&lang=js&"
export * from "./EbillSend.vue?vue&type=script&lang=js&"
import style0 from "./EbillSend.vue?vue&type=style&index=0&id=f0c08872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c08872",
  null
  
)

export default component.exports